/**
 * @author: Richard Scoones @ 29/11/2018
 * @description: GET and POST data securely to session server and cross tenants
 */
import { omit } from "lodash";
import API from "@irati/utils/services/API";
import { getDomain } from "@irati/utils/links";
import PostForm from "@irati/utils/PostForm";
import setIfNotSet from "@irati/utils/setIfNotSet";
import codes from "../errorCodes/Session";
var endpoint = "/api/v1/session-data";
var Session = /** @class */ (function () {
    function Session() {
    }
    Session.prototype.get = function (options) {
        if (options === void 0) { options = {}; }
        return API.get(endpoint, options).then(function (res) { return res.data; });
    };
    Session.prototype.post = function (data, options) {
        if (options === void 0) { options = {}; }
        setIfNotSet(options, "addCSRF", true);
        API.sentryIgnoreError(options, [codes.EBADCSRFTOKEN]);
        return API.post(endpoint, data, options).then(function (res) { return res.data; });
    };
    Session.prototype.postCrossDomain = function (targetSubDomain, data, options, autoSubmit) {
        if (data === void 0) { data = {}; }
        if (options === void 0) { options = {}; }
        if (autoSubmit === void 0) { autoSubmit = true; }
        var url = getDomain(targetSubDomain);
        var _a = options.pathname, pathname = _a === void 0 ? "" : _a, _b = options.target, target = _b === void 0 ? "" : _b;
        var form = PostForm("" + url + pathname, data, target);
        if (autoSubmit) {
            form.submit();
        }
        return Promise.resolve(form);
    };
    /**
     * @description: Get SessionData then remove the provided keys.
     *               Useful helper function to get one time values such as email on login.
     */
    Session.prototype.getThenRemove = function (keys, options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        return this.get(options).then(function (data) {
            var filtered = omit(data, keys);
            return _this.post(filtered, options).then(function () {
                // return original
                return data;
            });
        });
    };
    return Session;
}());
var session = new Session();
export var getSessionData = session.get;
export var postSessionData = session.post;
export var postCrossDomainSessionData = session.postCrossDomain;
export default session;
